<template>
  <div>
    <Topheader v-if="loginStatus" bg_color="#f6f6f6" bline="#EAEAEA"></Topheader>
    <Headerlogin v-else></Headerlogin>
    <div class="w1158">
      <div class="top-content">
        <div class="head-body">
          <img :src="userInfo.head_url" alt="">
        </div>
        <div class="head-right-body">
          <div class="info-title">
            <div class="info-name">{{userInfo.name}}</div>
            <div class="info-set" v-if="isSelf" @click="$router.push('/infoEditInfo')">编辑个人设定</div>
            <!--他人的-->
            <div class="info-link-follow" v-else>
              <div class="info-link" @click="onLink()">
                <img v-if="userInfo.is_link" src="../../static/icon/linkon.png" alt="">
                <img v-else src="../../static/icon/link.png" alt="">
                <div class="pink" v-if="userInfo.is_link">linked</div>
                <div class="word" v-else>link</div>
              </div>
              <div class="info-follow" @click="onFollow()">
                <img v-if="userInfo.is_follow" src="../../static/icon/followon.png" alt="">
                <img v-else src="../../static/icon/follow.png" alt="">
                <div class="yellow" v-if="userInfo.is_follow">following</div>
                <div class="word" v-else>follow</div>
              </div>
            </div>
          </div>
          <div class="info-spk">{{userInfo.introduce}}</div>
          <div class="info-count">
            <div class="info-cou">
              <div class="count-num">{{userInfo.posts}}</div>
              <div class="count-spk">Posts</div>
            </div>
            <div class="info-cou">
              <div class="count-num">{{userInfo.interflows}}</div>
              <div class="count-spk">Interflows</div>
            </div>
            <div class="info-cou">
              <div class="count-num">{{userInfo.searched}}</div>
              <div class="count-spk">Searched</div>
            </div>
          </div>
        </div>
      </div>
      <!--查看自己的显示才有发布-->
      <div v-if="isSelf" class="myUserinfo">
        <div v-if="selfStatus == 1" @click="ons()" class="upMessage">
          <div class="up-message">Here,Show Something about you</div>
        </div>
        <!--发布信息-->
        <div v-else class="upLoadMsg">
          <div class="upImg">
            <div class="addImg">
              <el-upload
                class="avatar-uploader"
                :action="common.uploadUrl()"
                :show-file-list="false"
                :before-upload="beforeAvatarUpload"
                :on-success="handleAvatarSuccess"
              >
                <div class="Img" v-if="imageUrl">
                  <img :src="imageUrl" class="avatar">
                </div>
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <div class="word2">添加图片</div>
            </div>
            <div class="fromWord">
              <div class="div1">
                <div class="div2">
                  <div class="div3">
                    <textarea
                      placeholder="你有什么事？"
                      name=""
                      id=""
                      cols="30"
                      rows="10"
                      v-model="subInfo.content"
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div class="postBtton" @click="subPost()">Post</div>
            <div class="word2" @click="canStatus()" style="cursor: pointer;">取消</div>
          </div>
        </div>
      </div>
      <div class="imgList">
        <div class="Img" v-for="(item,key) in imgList" :key="item.id" @click="bigImg(key)">
          <!-- :fit="cover" 图片变形， -->
          <!-- <el-image style="height: 100%;width: 100%;" :src="item.img_url" :fit="cover"></el-image> -->
          <img :src="item.img_url" alt="">
        </div>
      </div>
      <div
        class="loading"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(246, 246, 246, 0.8)"
      ></div>
    </div>
    <div class="bg" v-show="imgBigState" @click="clsoeImgBig()"></div>
    <div class="imgBig" v-show="imgBigState">
      <div class="imgBigAll">
        <div class="leftArrow" v-if="showKey > 0" @click="upClick()">
          <img src="../../static/icon/shang.png" alt="">
        </div>
        <div class="rightArrow" v-if="showKey < imgList.length-1" @click="nextClick()">
          <img src="../../static/icon/xia.png" alt="">
        </div>
        <div class="imgBigR">
          <!-- :fit="cover" 图片变形， -->
          <!-- <el-image style="width:616px; height:770px" :src="showInfo.info.img_url" :fit="cover"></el-image> -->
          <img :src="showInfo.info.img_url" alt="">
        </div>
        <div class="imgBigL">
          <div class="bigName">
            <div class="img">
              <img :src="showInfo.info.head_url" alt="">
            </div>
            <div class="name">{{showInfo.info.user_name}}</div>
          </div>
          <div class="word" v-html="showInfo.info.content"></div>
          <div
            class="wordNum"
            @click="toSeeinterflow(showInfo.info.id)"
          >全部{{showInfo.info.leave_num}}条发言</div>
          <ul class="talkWord">
            <li v-for="item in showInfo.leaveList" :key="item.id">
              <span class="name">{{item.user_name}}</span>
              {{item.content}}
            </li>
          </ul>
          <div class="interflowBottom">
            <div class="HightLight">
              <div class="HightLightNum">
                <img
                  v-if="showInfo.info.is_highlight"
                  src="../../static/icon/highlighton.png"
                  alt=""
                  @click="onHighlight()"
                >
                <img v-else src="../../static/icon/highlight.png" alt="" @click="onHighlight()">
                <span>{{showInfo.info.highlight_num}}次Highlight</span>
              </div>
              <div class="time">{{showInfo.info.create_time}}</div>
            </div>
            <div class="interFlow">
              <input
                type="text"
                v-model="content"
                v-on:keyup.enter="subInterflow()"
                placeholder="Interflow…"
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



<script>
  import Topheader from "../components/header"; //上传图片
  import Headerlogin from "../components/headerLogin"; //

  export default {
    components: {
      Topheader,Headerlogin
    },
    name: "userInfo",
    data() {
      return {
        id: null,
        listNum1: 2,
        listNum: 3,
        isSelf: false,
        selfStatus: 1,
        imgBigState: false, //弹窗
        imageUrl: "",
        userInfo: {},
        page: 1,
        page_num: 21,
        loading: false,
        loadingType: 0, //0=可以加载 1=加载中 2=已加载完毕
        imgList: [], //图片列表,
        subInfo: {
          content: "",
          imgs_id: "",
          type: 3
        },
        showKey: 0, //放大的数据,
        isGetShow: true, //是否可以请求
        showInfo: {
          info: {},
          leaveList: []
        },
        content: null,
        loginStatus:false,
      };
    },
    watch: {
      // 方法1
      $route(to, from) {
        //监听路由是否变化
        this.id = this.$route.query.id;
        this.getInfo();
        this.getImgList(); //获取图片列表
      }
    },
    mounted() {
      document
        .querySelector("body")
        .setAttribute("style", "background-color:#f6f6f6");
    },
    created() {
      this.id = this.$route.query.id;
      this.getInfo();
      this.getImgList(); //获取图片列表
      window.addEventListener("scroll", this.onScroll);
        this.loginStatus=this.common.isLogin();
    },
    methods: {
      canStatus() {
        this.selfStatus = 1;
      },
      beforeAvatarUpload(file) {
        const isJPG = file.type === "image/jpeg" || file.type === "image/png";

        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isJPG) {
          this.$message.error("上传图片只能是 JPEG 或 JPG 或 PNG 格式!");
        }
        if (!isLt2M) {
          this.$message.error("上传图片大小不能超过 2MB!");
        }
        return isJPG && isLt2M;
      },
      toSeeinterflow(id) {
        this.$router.push({
          path: "/seeinterflow",
          query: {
            id: id
          }
        });
      },
      //留言
      subInterflow() {
        let _this = this;
          if(!_this.common.isLogin()){
              _this.common.onLoginSure();
              return;
          }
        let data = {
          dynamic_id: _this.imgList[_this.showKey].id,
          content: _this.content
        };
        _this.common.request(
          "api/dynamicLeave/interflow",
          data,
          function(res) {
            if (res.status == 200) {
              _this.common.vMessage(res.message);
              _this.showInfo.info.leave_num = res.data.leave_num;
              _this.showInfo.leaveList = res.data.leaveList; //更新发言
              _this.content = null;
            }
          },
          "post"
        );
      },
      //发布个人主页信息
      subPost() {
        let _this = this;
          if(!_this.common.isLogin()){
              _this.common.onLoginSure();
              return;
          }
        _this.common.request(
          "api/dynamic/add",
          _this.subInfo,
          function(res) {
            if (res.status == 200) {
              _this.$message({
                message: res.message,
                type: "success",
                duration: 1500,
                center: true,
                onClose: function(res) {
                  _this.subInfo = {
                    content: "",
                    imgs_id: "",
                    type: 3
                  };
                  _this.imageUrl = null;
                  _this.getImgList();
                  _this.selfStatus = 1; //发布状态
                }
              });
            }
          },
          "post"
        );
      },
      //获取个人主页图片列表
      getImgList() {
        let _this = this;
        _this.page = 1;
        let data = {
          id: _this.id,
          page: _this.page,
          page_num: _this.page_num
        };
        _this.common.request("api/dynamic/userHomeList", data, function(res) {
          if (res.status == 200) {
            _this.imgList = res.data.list;
          }
        });
      },
      //获取信息
      getInfo() {
        let _this = this;
        _this.common.request("api/user/info", { id: _this.id }, function(res) {
          if (res.status == 200) {
            _this.userInfo = res.data;
            _this.isSelf = res.data.is_self;
          }
        });
      },
      //link操作
      onLink() {
        let _this = this;
          if(!_this.common.isLogin()){
              _this.common.onLoginSure();
              return;
          }
        _this.common.request(
          "api/userLinker/handel",
          { id: _this.id },
          function(res) {
            if (res.status == 200) {
              _this.userInfo.is_link = !_this.userInfo.is_link;
              _this.common.vMessage(res.message);
            }
          },
          "post"
        );
      },
      //follow操作
      onFollow() {
        let _this = this;
          if(!_this.common.isLogin()){
              _this.common.onLoginSure();
              return;
          }
        _this.common.request(
          "api/userFollow/handel",
          { id: _this.id },
          function(res) {
            if (res.status == 200) {
              _this.userInfo.is_follow = !_this.userInfo.is_follow;
              _this.common.vMessage(res.message);
            }
          },
          "post"
        );
      },
      //上传图片
      handleAvatarSuccess(res, file) {
        this.subInfo.imgs_id = res.data.id;
        this.imageUrl = URL.createObjectURL(file.raw);
      },
      //点击高光
      onHighlight() {
        let _this = this;
          if(!_this.common.isLogin()){
              _this.common.onLoginSure();
              return;
          }
        let id = _this.imgList[_this.showKey].id;
        _this.common.request(
          "api/dynamic/highlight",
          { id: id },
          function(res) {
            if (res.status == 200) {
              _this.showInfo.info.highlight_num = res.data.highlight_num; //
              _this.showInfo.info.is_highlight = !_this.showInfo.info
                .is_highlight; //
            }
          },
          "post"
        );
      },
      //上一页
      upClick() {
        if (this.showKey > 0) {
          this.bigImg(this.showKey - 1); //上一页
        }
      },
      //下一页
      nextClick() {
        if (this.showKey < this.imgList.length - 1) {
          this.bigImg(this.showKey + 1); //上一页
        }
      },
      //显示弹窗
      bigImg(obj) {
        let _this = this;
        let id = _this.imgList[obj].id;

        //不能请求
        if (!_this.isGetShow) {
          return;
        }
        _this.isGetShow = false;
        _this.common.request("api/dynamic/grInfo", { id: id }, function(res) {
          _this.isGetShow = true;
          _this.imgBigState = true;
          _this.showInfo = res.data;
          _this.showKey = obj;
        });
      },
      //关闭弹窗
      clsoeImgBig() {
        this.imgBigState = false;
      },

      ons() {
        this.selfStatus = 2; //发布状态
      },
      //加载跟多
      onScroll() {
        //可滚动容器的高度
        let innerHeight = document.querySelector("#app").clientHeight;
        //屏幕尺寸高度
        let outerHeight = document.documentElement.clientHeight;
        //可滚动容器超出当前窗口显示范围的高度
        let scrollTop = document.documentElement.scrollTop;
        //scrollTop在页面为滚动时为0，开始滚动后，慢慢增加，滚动到页面底部时，出现innerHeight < (outerHeight + scrollTop)的情况，严格来讲，是接近底部。

        if (innerHeight <= outerHeight + scrollTop) {
          let _this = this;
          if (_this.loadingType != 0) {
            return;
          }
          _this.loadingType = 1;
          _this.loading = true;
          _this.page++;
          let list = [];
          let data = {
            id: _this.id,
            page: _this.page,
            page_num: _this.page_num
          };
          _this.common.request("api/dynamic/userHomeList", data, function(res) {
            if (res.status == 200) {
              list = res.data.list; //请求数据
              _this.loading = false;
              if (res.data.list_num <= 0) {
                _this.loadingType = 2;
                return;
              }
              _this.imgList = _this.imgList.concat(list);
              _this.loadingType = 0;
            }
          });
        }
      }
    }
  };
</script>

<style scoped lang='less'  rel="stylesheet/less">
  @import "../assets/css/index.less";

  .top-content {
    display: flex;
    justify-content: flex-start;
    padding: 20px 0 0px 0;
    width: 773px;
    margin: 0 auto;
  }

  .head-body {
    margin-right: 38px;
    margin-top: 23px;
    text-align: center;
    img {
      width: 130px;
      height: 130px;
      border-radius: 50%;
      margin: 0 auto;
    }
  }

  .head-right-body {
    width: 605px;
  }

  .info-title {
    width: 100%;
    display: flex;
    justify-content: flex-start;
  }

  .info-name {
    font-weight: 600;
    font-size: 18px;
  }
  .info-set {
    margin-left: 20px;
    font-size: 14px;
    color: #187eb9;
    cursor: pointer;
  }
  .info-set:hover {
    text-decoration: underline;
  }

  .info-spk {
    width: 605px;
    font-size: 16px;
    font-weight: normal;
    color: rgba(91, 91, 91, 1);
    height: 66px;
    .thteeLines;
    margin: 24px 0 20px 0;
  }

  .info-count {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 36px;
  }

  .info-cou {
    margin-left: 40px;
  }

  .count-num {
    font-size: 22px;
    font-weight: bold;
    margin-bottom: 12px;
  }

  .count-spk {
    font-size: 14px;
    color: #8b8b8b;
  }

  .info-count .info-cou:first-child {
    margin-left: 0;
  }
  .upMessage {
    border-top: 0.5px solid #eaeaea;
    border-bottom: 0.5px solid #eaeaea;
    height: 60px;
    line-height: 60px;
    margin-bottom: 40px;

    .up-message {
      text-align: center;
      color: #6b6b6b;
      cursor: pointer;
      text-align: left;
      width: 737px;
      padding-left: 36px;
      margin: 0 auto;
    }
  }

  // 上传
  .upLoadMsg {
    width: 773px;
    margin: 20px auto;
    padding-bottom: 40px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    .upImg {
      .flexStart;
    }
    .addImg {
      width: 100px;
      height: 100px;
      margin-right: 38px;
      background: #d7d7d7;
      .Img {
        .imgCover(100px, 100px);
      }
    }
    .fromWord {
      width: 511px;
      color: #afafaf;
      height: 87px;
      overflow: auto;

      .div1 {
        width: 511px;
        height: 87px;
        position: relative;
        overflow: hidden;
      }
      .div2 {
        overflow-x: hidden;
        overflow-y: scroll;
        position: absolute;
      }
      .div3 {
        width: 511px;
        height: 87px;
      }
      textarea {
        overflow: hidden;
        resize: none;
        color: #1d1d1d;
        font-size: 14px;
        outline: none;
        resize: none;
        border: none;
        background: transparent;
        margin-top: 20px;
        width: 511px;
        height: 87px;
      }
    }
    .postBtton {
      width: 62px;
      height: 26px;
      line-height: 26px;
      background: #188ddf;
      color: #fff;
      font-size: 14px;
      text-align: center;
      border-radius: 13px;
      cursor: pointer;
    }
    .postBtton:hover {
      background: rgba(24, 141, 223, 0.7);
    }
  }

  /*lists*/
  .list-body {
    position: relative;
  }
  .list-body2 {
    display: flex;
    justify-content: space-between;
  }

  .list-info {
    height: 358px;
    width: 358px;
    margin-top: 10px;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
  }

  .loading {
    width: 100%;
    height: 40px;
    text-align: center;
    background-color: #f6f6f6;
  }

  // 弹窗
  .imgBig {
    position: fixed;
    top: 50%;
    left: 50%;
    width: 1088px;
    height: 770px;
    z-index: 101;
    margin-left: -544px;
    margin-top: -385px;
    background: #fff;
    .el-carousel__container {
      height: 770px !important;
    }

    .imgBigAll {
      .leftArrow,
      .rightArrow {
        position: absolute;
        top: 50%;
        margin-top: -10px;
        color: #000;
        font-size: 12px;
        cursor: pointer;
        padding: 10px;
      }
      .leftArrow {
        left: -60px;
      }
      .rightArrow {
        right: -60px;
      }
      display: flex;
      justify-content: space-between;
      .imgBigR {
        .imgCover(616px, 770px);
      }
      .imgBigL {
        width: 472px;
        padding: 16px 26px;
        position: relative;
        .bigName {
          .flexStart;
          padding-bottom: 16px;
          border-bottom: 1px solid #ebebeb;
          .img {
            margin-right: 15px;
            img {
              width: 44px;
              height: 44px;
              .border-radius(50%);
            }
          }
          .name {
            color: #1d1d1d;
            font-size: 14px;
          }
        }

        .word {
          margin-top: 16px;
          color: #6d6d6d;
          font-size: 14px;
          line-height: 24px;
        }
        .wordNum {
          color: #7f7f7f;
          font-size: 14px;
          margin-top: 14px;
          margin-bottom: 29px;
          cursor: pointer;
        }
        .wordNum:hover {
          text-decoration: underline;
        }
        .talkWord {
          height: 340px;
          overflow-y: auto;
          li {
            margin-bottom: 13px;
            font-size: 14px;
            color: #4d4d4d;
            .name {
              color: #4d4d4d;
            }
          }
        }

        .interflowBottom {
          position: absolute;
          bottom: 16px;
          width: calc(100% - 40px);
        }
        .HightLight {
          padding: 16px 0;
          .HightLightNum {
            .flexStart;
            margin-bottom: 20px;
            img {
              width: 18px;
              height: 18px;
              margin-right: 14px;
              cursor: pointer;
            }
            span {
              color: #27292a;
              font-size: 14px;
              font-weight: bold;
            }
          }
          .time {
            color: #7f7f7f;
            font-size: 16px;
            font-weight: 400;
          }
        }
        .interFlow {
          border-top: 1px solid #e0e0e0;
          padding-top: 26px;
          input {
            color: #7f7f7f;
            font-size: 18px;
            width: 100%;
          }
        }
      }
    }
  }
  .imgBigTan {
    position: fixed;
    top: 0;
    left: 50%;
    margin-left: -550px;
  }

  // 上传图片
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
  .avatar {
    width: 100px;
    height: 100px;
    display: block;
  }

  .el-carousel__container {
    height: 770px !important;
  }

  .info-link-follow {
    display: flex;
    justify-content: flex-start;
  }

  .info-link {
    .word {
      color: #187eb9;
    }
    .pink {
      color: #de27de;
    }
  }
  .info-follow {
    .yellow {
      color: #c4bc3d;
    }
    .word {
      color: #187eb9;
    }
  }
  .info-link,
  .info-follow {
    display: flex;
    justify-content: flex-start;
    margin-left: 20px;
    color: #187eb9;
    align-items: center;
    font-weight: 600;
    cursor: pointer;
    img {
      width: 20px;
      height: 20px;
      margin-right: 5px;
    }
    div:hover {
      text-decoration: underline;
    }
  }

  /*图片list*/
  .imgList {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    align-content: space-around;
    .Img {
      margin-right: 42px;
      margin-bottom: 48px;
      .imgCover(358px, 358px);
    }
    .Img:nth-child(3n) {
      margin-right: 0;
    }
  }
  .myUserinfo {
  }
  .upMessage {
  }
  .word2 {
    color: #166593;
    font-size: 14px;
    text-align: center;
    margin-top: 17px;
  }
</style>


// WEBPACK FOOTER //
// src/view/userInfo.vue